import store from "@/store/store.js"
import Vue from "@/main";

export default {
    SET_SUM_OF_TICKETS(state, sumOfTickets) {
        state.sumOfTickets = sumOfTickets;
    },
    PREPARE_SUM_OF_TICKETS(state, { type:type, data: data }){
        const { AppActiveUser: activeUser } = store.state;
        const { id, inbox, inbox_department_id, user_id, previous_user_id, is_campaign, instance_id, bot_is_active, customer_id, is_research, unseenMsg } = data;

        if ( type === "transfer" ){
            if ( !user_id && !previous_user_id ) return;

            if ( !previous_user_id ){
                if (
                    (!inbox_department_id) ||
                    (activeUser.userDepartment && inbox_department_id === activeUser.userDepartment.id)
                ){ store.dispatch('chatSettings/subInSumOfTickets', {
                    'data': {
                        'id':id,
                        'is_campaign':is_campaign,
                        'instance_id':instance_id,
                        'customer_id': customer_id,
                        'bot_is_active':bot_is_active,
                        'is_research': is_research,
                        'unseenMsg': unseenMsg
                    },
                    'inInbox' : true
                }) }

                if (
                    activeUser.id === user_id
                ){ store.dispatch('chatSettings/addInSumOfTickets', {
                    'data': {
                        'id':id,
                        'is_campaign':is_campaign,
                        'instance_id':instance_id,
                        'customer_id': customer_id,
                        'bot_is_active':bot_is_active,
                        'is_research': is_research,
                        'unseenMsg': unseenMsg
                    },
                    'inInbox' : false
                }) }
            } else {
                if (
                    activeUser.id === previous_user_id
                ){ store.dispatch('chatSettings/subInSumOfTickets', {
                    'data': {
                        'id':id,
                        'is_campaign':is_campaign,
                        'instance_id':instance_id,
                        'customer_id': customer_id,
                        'bot_is_active':bot_is_active,
                        'unseenMsg': unseenMsg
                    },
                    'inInbox' : false
                }) }

                if (
                    activeUser.id === user_id
                ){ store.dispatch('chatSettings/addInSumOfTickets', {
                    'data': {
                        'id':id,
                        'is_campaign':is_campaign,
                        'instance_id':instance_id,
                        'customer_id': customer_id,
                        'bot_is_active':bot_is_active,
                        'is_research': is_research,
                        'unseenMsg': unseenMsg
                    }, 'inInbox' : false
                }) }
                else if (
                    !user_id
                ){ store.dispatch('chatSettings/addInSumOfTickets', {
                    'data': {
                        'id':id,
                        'is_campaign':is_campaign,
                        'instance_id':instance_id,
                        'customer_id': customer_id,
                        'bot_is_active':bot_is_active,
                        'is_research': is_research,
                        'unseenMsg': unseenMsg
                    },
                    'inInbox' : true
                }) }
            }
        } else if ( type === "removed" ){
            if (
              !user_id && inbox && activeUser.id === previous_user_id
            ) { store.dispatch('chatSettings/subInSumOfTickets', {
                'data': {
                    'id':id,
                    'is_campaign':is_campaign,
                    'instance_id':instance_id,
                    'customer_id': customer_id,
                    'bot_is_active':bot_is_active,
                    'is_research': is_research,
                    'unseenMsg': unseenMsg
                },
                'inInbox' : false
            }) }
            else if (
                !inbox && activeUser.id === user_id
                || (
                    inbox && (
                        (activeUser.role.name === 'administrador' || !inbox_department_id) ||
                        (activeUser.userDepartment && inbox_department_id !== activeUser.userDepartment.id)
                    )
            )){ store.dispatch('chatSettings/subInSumOfTickets', {
                'data': {
                    'id':id,
                    'is_campaign':is_campaign,
                    'instance_id':instance_id,
                    'customer_id': customer_id,
                    'bot_is_active':bot_is_active,
                    'is_research': is_research,
                    'unseenMsg': unseenMsg
                },
                'inInbox' : activeUser.id !== user_id
            }) }
        } else if ( type === "insert" ){
            if (
                !inbox && activeUser.id === user_id
                || (
                    inbox && (
                        (activeUser.role.name === 'administrador' || !inbox_department_id) ||
                        (activeUser.userDepartment && inbox_department_id === activeUser.userDepartment.id)
                    )
            )){ store.dispatch('chatSettings/addInSumOfTickets', {
                'data': {
                    'id':id,
                    'is_campaign':is_campaign,
                    'instance_id':instance_id,
                    'customer_id': customer_id,
                    'bot_is_active':bot_is_active,
                    'is_research': is_research,
                    'unseenMsg': unseenMsg
                },
                'inInbox' : activeUser.id !== user_id
            }) }
        } else if ( type === "updated" ){
            store.dispatch('chatSettings/updateInSumOfTickets', {
                'data': {
                    'id':id,
                    'is_campaign':is_campaign,
                    'instance_id':instance_id,
                    'customer_id': customer_id,
                    'bot_is_active':bot_is_active,
                    'is_research': is_research,
                    'unseenMsg': unseenMsg
                }})
        }
    },
    ADD_IN_SUM_OF_TICKETS(state, {'data': data, 'inInbox' : inInbox}){
        if ( inInbox && ( state.sumOfTickets.inbox_list.findIndex((item) => item.id === data.id) === -1 )){
            state.sumOfTickets.inbox_list.push(data);
        } else if ( !inInbox && ( state.sumOfTickets.my_chats_list.findIndex((item) => item.id === data.id) === -1 )) {
            state.sumOfTickets.my_chats_list.push(data);
        }
    },
    SUB_IN_SUM_OF_TICKETS(state, {'data': data, 'inInbox' : inInbox}){
        if (inInbox && state.sumOfTickets.inbox_list.length > 0) {
            const index = state.sumOfTickets.inbox_list.findIndex((item) => item.id === data.id);
            if (index !== -1) {
                state.sumOfTickets.inbox_list.splice(index, 1);
                Vue.$events.fire('CheckPagination', { inInbox })
            }
        } else if (!inInbox && state.sumOfTickets.my_chats_list.length > 0) {
            const index = state.sumOfTickets.my_chats_list.findIndex((item) => item.id === data.id);
            if (index !== -1) {
                state.sumOfTickets.my_chats_list.splice(index, 1);
                Vue.$events.fire('CheckPagination', { inInbox })
            }
        }
    },
    UPDATE_IN_SUM_OF_TICKETS(state, {'data': data}) {
        const { id, is_campaign, bot_is_active, unseenMsg } = data;

        if ( state.sumOfTickets.inbox_list.length > 0 && state.sumOfTickets.my_chats_list.length > 0){
            const indexInbox = state.sumOfTickets.inbox_list.findIndex((item) => item.id === id);
            const indexMyChats = state.sumOfTickets.my_chats_list.findIndex((item) => item.id === id);

            if ( indexInbox !== -1 ) {
                state.sumOfTickets.inbox_list[indexInbox].is_campaign        = Number(is_campaign);
                state.sumOfTickets.inbox_list[indexInbox].bot_is_active      = Number(bot_is_active);
                state.sumOfTickets.inbox_list[indexInbox].unseenMsg          = Number(unseenMsg)
            } else if ( indexMyChats !== -1 ) {
                state.sumOfTickets.my_chats_list[indexMyChats].is_campaign   = Number(is_campaign);
                state.sumOfTickets.my_chats_list[indexMyChats].bot_is_active = Number(bot_is_active);
                state.sumOfTickets.my_chats_list[indexMyChats].unseenMsg     = Number(unseenMsg)
            }
        }
    }
}

